import { z } from 'zod/v4';

import { LLMConfigSchema } from './llm.schema';
import { ElementSchema } from './tarot.schema';

export const UserRoleSchema = z.enum(['user', 'reader_pro', 'admin', 'superadmin']);
export const PreferredBackendSchema = z.enum(['hosted', 'external', 'local', 'auto']);
export const EntropyPreferenceSchema = z.enum([
  'auto',
  'quantum_only',
  'crypto_only',
  'server_only',
]);
export const LanguageSchema = z.enum(['it', 'en']);
export const AnimationSpeedSchema = z.enum(['slow', 'normal', 'fast']);

export const UserPreferencesSchema = z.object({
  lilith_mode: z.boolean(),
  kabbalistic_overlay: z.boolean(),
  qliphotic_readings: z.boolean(),
  show_decan_info: z.boolean(),
  show_angelic_info: z.boolean(),
  show_dignity_info: z.boolean(),
  show_temporal_info: z.boolean(),
  llm_local: LLMConfigSchema.nullable(),
  llm_remote: LLMConfigSchema.nullable(),
  preferred_backend: PreferredBackendSchema,
  entropy_preference: EntropyPreferenceSchema,
  language: LanguageSchema,
  ritual_mode: z.boolean(),
  animation_speed: AnimationSpeedSchema,
  show_audit_trail: z.boolean(),
  auto_save_readings: z.boolean(),
  significator_card_id: z.number().int().nonnegative().nullable(),
  birth_decan: z.number().int().positive().nullable(),
  natal_element: ElementSchema.nullable(),
});

export const UserSchema = z.object({
  id: z.string().min(1),
  email: z.string().email(),
  display_name: z.string().min(1),
  role: UserRoleSchema,
  preferences: UserPreferencesSchema,
  created_at: z.string().min(1),
  last_reading_at: z.string().min(1).nullable(),
  total_readings: z.number().int().nonnegative(),
  wp_user_id: z.number().int().nonnegative().nullable(),
});
